/**
 * Resolves an image URL so it is fully qualified with the backend API URL.
 */
export function resolveImageUrl(url: string | null | undefined): string {
  if (!url) return ''

  const trimmed = url.trim()
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null' || trimmed === 'localhost' || trimmed === 'default') {
    return ''
  }

  // Already absolute URL, data URI or blob
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed
  }

  const rawApiBase = import.meta.env.VITE_API_URL
  const isRemoteBrowser =
    typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'

  // In remote browser without VITE_API_URL, keep relative path instead of failing on localhost:3000
  const apiBase = rawApiBase || (isRemoteBrowser ? '' : 'http://localhost:3000')
  const cleanBase = apiBase.replace(/\/$/, '')
  const cleanPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`

  // Prevent /api/api duplicate prefix
  if (cleanBase.endsWith('/api') && cleanPath.startsWith('/api/')) {
    return `${cleanBase}${cleanPath.substring(4)}`
  }

  return `${cleanBase}${cleanPath}`
}

